import useSWR from 'swr';
import { customSWRConfig, customSWRResponse } from '../../../model/types';
import { isValidNumberForRequest } from '../../../utils/validation';
import useSWRCacheKeys from '../../useSWRCacheKeys';
import { Filter } from './useFilters';

// TODO: re-factor, remove id parameter and get id form useRouter hook
export default function useCurrentFilter(id: number, config: customSWRConfig = {}): customSWRResponse<Filter> {
    const keys = useSWRCacheKeys(isValidNumberForRequest(id) ? `/filters/byId/${id}` : null);

    return useSWR<Filter>(keys, { ...config });
}
